import React from 'react';
import SIcon from './SIcon';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';

const Icon = props => <SIcon {...props} icon={faTriangleExclamation} fa />;

export default Icon;
